import {Link} from "react-router";

interface YouReachedPlanMaximumProps {
  limitName: string;
  plan: string;
  canPurchase: boolean;
}

export const YouReachedPlanMaximum = ({limitName, plan, canPurchase}: YouReachedPlanMaximumProps) => (
  <small>
    <p>
      You have reached the maximum number of <strong>{limitName}</strong> Checks available in your current {plan} plan.
    </p>
    {canPurchase && <p>In order to add more Checks proceed to the Manage Subscription page to select a new plan.</p>}
    {!canPurchase && (
      <p>
        In order to upgrade your plan and add more Checks the owner of this account must be notified. Use the “Send
        Request” button to notify the account owner.
      </p>
    )}
    <p>
      If you have any questions don’t hesitate to <Link to="/contact">contact us</Link>.
    </p>
  </small>
);
